fragment DocumentRecipientMetadata on Document {
  id
  recipientMetadata {
    name
  }
}
